import moment from "moment";

// Filter mapping for URL query params
export const getQueryFilterMap = (query) => {
  const filterMap = {
    "todays-due-date": {
      due_date_from: moment().format("YYYY-MM-DD"),
      due_date_to: moment().format("YYYY-MM-DD"),
    },
  };
  return filterMap[query] || null;
};
